import { INBOX } from "icons";
import { NavItemWithBadge } from "@/components/nav/nav-item-with-badge";
import { getNotificationsFromDirectus } from "directus/src/operations";

const fetchNotificationsCount = (_endpoint, { query }) =>
  getNotificationsFromDirectus({
    ...query,
    aggregate: { countDistinct: ["id"] },
  });

export function InboxNavigations() {
  return (
    <NavItemWithBadge
      title="Inbox"
      icon={INBOX}
      url="/inbox"
      collection="directus_notifications"
      filters={{
        recipient: { _eq: "$CURRENT_USER" },
        status: { _eq: "inbox" },
      }}
      fetchCount={fetchNotificationsCount}
    />
  );
}
